export function filteredEvents(state) {
  let events = state.events;

  //FILTRO PARA OBTENER LOS EVENTOS DEPENDIENDO DE LA ETIQUETA
  if (state.filter.category)
    events = events.filter(event => event.category === state.filter.category)

  //FILTRO PARA OBTENER LOS EVENTOS POR CATEGORÍA
  if (state.filter.subcategory && state.filter.subcategory != 'Todos')
    events = events.filter(event => event.subcategory === state.filter.subcategory)


  //FILTRO PARA OBTENER LOS EVENTOS POR MODALIDAD
  if (state.filter.modality && state.filter.modality != 'Todas')
    events = events.filter(event => event.modality.includes(state.filter.modality))

  //FILTRO PARA OBTENER LOS EVENTOS POR NOMBRE
  if (state.filter.name && state.filter.name != ''){
    let name = state.filter.name.toLowerCase();
    events = events.filter(event => event.name.toLowerCase().includes(name)||event.organizer.companyName.toLowerCase().includes(name)||event.tags.includes(state.filter.name));
    //events = events.filter(event => event.name.toLowerCase().includes(name)||event.organizer.companyName.toLowerCase().includes(name));
  }
  return events;
}
